//'React' must be in scope when using JSX  react/react-in-jsx-scope
import React from 'react';
import PropTypes from 'prop-types';

const Chips = ({ chips, suggestions, onClose, onAdd }) => {
    console.log(chips, suggestions, onClose, onAdd);
    if (!chips || !Array.isArray(chips)) {
        console.error('Chips prop must be an array');
        return null;
    }

    if (suggestions && !Array.isArray(suggestions)) {
        console.error('Suggestions prop must be an array');
        return null;
    }

    const filteredSuggestions = suggestions ? suggestions.filter(suggestion => !chips.includes(suggestion)) : [];

    return (
        <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {chips.map((chip, index) => (
                <div key={index} className="chip" style={{ fontSize: 14, padding: '8px', backgroundColor: '#e0e0e0', borderRadius: '16px', display: 'flex', alignItems: 'center' }}>
                    {chip}
                    <span className="closebtn" onClick={() => onClose(chips.filter((item) => item !== chip))} style={{backgroundColor: "white", borderRadius: 28,paddingBottom: 3,height: 20, width: 20, textAlign: 'center', marginLeft: 3}}>&times;</span>
                </div>
            ))}
            <span style={{width: '100%', borderTop: '1px solid #ccc'}}></span>
            {filteredSuggestions && filteredSuggestions.length > 0 && (
                <div className="suggestions" style={{ marginTop: '8px', color: '#888' }}>
                    <span style={{color: "rgb(33, 37, 41)"}}>Suggesties: </span>
                    {filteredSuggestions.map((suggestion, index) => (
                        <span key={index} className="suggestion" style={{ color: "rgb(33, 37, 41)", fontSize: 14, padding: '8px', marginRight: '8px', backgroundColor: '#e0e0e0', borderRadius: 16 }} onClick={() => onAdd([...chips, suggestion])}>{suggestion} <span style={{backgroundColor: "white", borderRadius: 28,paddingBottom: 3,height: 20, width: 20, textAlign: 'center', marginLeft: 3, display: "inline-block"}}>+</span></span>
                    ))}
                </div>
            )}
        </div>
    );
}

Chips.propTypes = {
    chips: PropTypes.arrayOf(PropTypes.string).isRequired,
    onClose: PropTypes.func.isRequired,
    onAdd: PropTypes.func,
    suggestions: PropTypes.arrayOf(PropTypes.string)
};

export default Chips;
